import { BowlingAnimation } from "@/components/ui/bowling-animation";
import { cn } from "@/lib/utils";

export type LoadingProps = {
  label?: string;
  /**
   * Csak dísz: nincs címke és nincs státuszrégió, a képernyőolvasó nem látja. Ahol a környezet
   * maga mondja ki, mi történik, és maga az élő régió (a `BookingResultCard` fejléce)
   */
  decorative?: boolean;
  className?: string;
  fullHeight?: boolean;
  size?: "sm" | "md" | "lg";
};

const animationSize: Record<NonNullable<LoadingProps["size"]>, string> = {
  sm: "size-10",
  md: "size-16",
  lg: "size-24",
};

/**
 * Töltésjelző, ami csak ~300 ms után válik láthatóvá (`animate-loading-in`): a rövid
 * betöltéseknél - cache-ből jövő adat, már letöltött route-chunk - a tartalom egyszerűen
 * megjelenik, nem villan fel előtte egy animáció. Ami tényleg lassú, annál az Arizona
 * animált bowling bábui jelennek meg a márka zöld színeiben. A helyét addig is foglalja,
 * így nem ugrik az elrendezés.
 * Gombon belüli, azonnali visszajelzéshez a `Button` `loading` propja való (az egyszerű `Spinner`-rel).
 * `decorative`-val csak az animáció áll, címke és státuszrégió nélkül: így egy ikon helyére is
 * tehető, ahol a környezet mondja ki, mi történik, és az élő régió is a környezeté: kettő
 * egymás mellett kétszer szólna.
 */
export function Loading({
  label = "Betöltés...",
  decorative = false,
  className,
  fullHeight = true,
  size = "md",
}: LoadingProps) {
  if (decorative) {
    return (
      <div aria-hidden className={cn("flex justify-center animate-loading-in", className)}>
        <BowlingAnimation className={animationSize[size]} />
      </div>
    );
  }

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center animate-loading-in",
        fullHeight ? "py-10" : undefined,
        className
      )}
      role="status"
      aria-live="polite"
    >
      <BowlingAnimation className={cn(label && "mb-3", animationSize[size])} />
      {label && <div className="text-sm text-muted-foreground">{label}</div>}
    </div>
  );
}
